@if(isEditing){
    <div class="bg-card  p-10">
        <quill-editor
                [(ngModel)]="componentModel.content.value"
                [modules]="editorModules"
                [styles]="{'min-height': '300px', 'color': 'var(--text-normal) !important'}"
                [placeholder]="'write_something'| translate"
                [format]="'html'"></quill-editor>
        <div class="flex justify-end gap-4 mt-4">
            <white-label-button type="secondary" [text]="'cancel' | translate" (onClick)="cancel()"></white-label-button>
            <white-label-button type="secondary" [text]="'autocomplete' | translate" (onClick)="autocompleteAndSave()"></white-label-button>
            <white-label-button type="primary" [text]="'save' | translate" (onClick)="save()"></white-label-button>
        </div>
    </div>


} @else {
    <div class="max-w-7xl mx-auto prose">
        <div class="mt-10 text-normal ql-editor" [innerHTML]="componentModel.content.value">
        </div>
    </div>
}


